import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import App from './App';
import './index.css';

const oidcConfig = {
  authority: process.env.REACT_APP_KEYCLOAK_URL
    ? `${process.env.REACT_APP_KEYCLOAK_URL}/realms/konitys`
    : 'https://plateform-auth.orkessidev.com/realms/konitys',
  client_id: 'plateform-frontend',
  redirect_uri: window.location.origin + '/',
  post_logout_redirect_uri: window.location.origin + '/',
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  onSigninCallback: (user) => {
    // Exposer le token Keycloak pour le HeaderBar fédéré (compteur tâches)
    if (user?.access_token) {
      window.__KONITYS_AUTH = { token: user.access_token };
    }
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
